import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.search";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from "@/components/rw/tempTable/index";
import tempSearch from "@/components/rw/tempSearch/index";
import tempForm from "@/components/rw/tempForm/index";
import tempChart from "@/components/rw/tempChart/index";
import { configGradeList, sendCmd, staticCommon } from '@/api/apis';
import importPage from '@/views/pages/reports/staticCommon/importPage';
export default {
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart,
    importPage: importPage
  },
  data: function data() {
    var _this = this;

    return {
      staticList: [{
        key: 'sta2',
        value: '对应所属派系'
      }, {
        key: 'sta3',
        value: '最近所属关系'
      }, {
        key: 'sta4',
        value: '点位过滤'
      }],
      gradeList: [],
      searchModel_1000: {
        "del": false,
        "id": "id_1000",
        "isCollapse": false,
        "operateData": [{
          "icon": "el-icon-search",
          "tag": "search",
          "title": "搜索",
          "type": "primary"
        }, {
          "icon": "el-icon-position",
          "tag": "export",
          "title": "导出",
          "type": "primary"
        }],
        "searchData": [{
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "",
              "value": ""
            }],
            "title": "分类一",
            "type": "button"
          }, {
            "field": [{
              "key": "",
              "value": ""
            }],
            "title": "分类二",
            "type": "button"
          }],
          "id": 0,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 0,
          "select": 0,
          "title": "统计分类",
          "type": 0,
          "remoteFunc": ["modelFunc_0"]
        }],
        "type": "searchTemplate"
      },
      tableModel_1001: {
        "type": "tableTemplate",
        "id": "id_1001",
        "del": false,
        "tableModel": [{
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key0"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key1"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key2"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key3"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key4"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key5"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key6"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key7"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key8"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key9"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key10"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key11"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key12"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key13"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key14"
        }, {
          "label": "新字段",
          "show": 1,
          "add": 1,
          "detail": 1,
          "width": null,
          "type": "text",
          "desc": "",
          "groupId": "",
          "rules": [],
          "excel": 1,
          "prop": "key15"
        }],
        "tableSwitchProps": {},
        "tableSelectProps": {},
        "tableCascaderProps": {},
        "tableFileProps": {},
        "rowButton": [],
        "stripe": true,
        "border": true,
        "showPagination": true,
        "showSelection": false,
        "showSummary": false,
        "title": "统计",
        "tableName": "",
        "isGroup": false,
        "isTree": false,
        "headerButton": [],
        "tableAutocompleteProps": {},
        "tableRadioProps": {}
      },
      remoteFunc: {
        modelFunc_0: function modelFunc_0(tag, relationData, resolve) {
          //筛选条件数据
          var data = [];

          for (var i in _this.staticList) {
            var item = _this.staticList[i];
            data.push({
              type: _this.$tempModel.searchType.button,
              title: item.value,
              field: [{
                key: 'type',
                value: item.key
              }]
            });
          }

          resolve(tag, data);
        }
      }
    };
  },
  created: function created() {
    var _this2 = this;

    this.cacheTableModel = this.$tempModel.deepCopy(this.tableModel_1001.tableModel);
    configGradeList({}).then(function _callee(res) {
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.gradeList = res;

              _this2.table.reloadData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      });
    });
  },
  mounted: function mounted() {
    this.table = this.$refs.ref_1001;
    this.search = this.$refs.ref_1000;
  },
  methods: {
    clickType: function clickType(tag) {
      var _this3 = this;

      this.$refs.importPage.show(tag, function () {
        _this3.table.reloadData();
      });
    },
    reqTableData: function reqTableData(params, resolve) {
      var _this4 = this;

      var where = {};

      if (this.search) {
        where = this.search.parseWhere();
        params.where = where;
        var tableModel = this.$tempModel.deepCopy(this.cacheTableModel);

        if (params.where.type === 'sta2') {
          for (var i in tableModel) {
            var key = tableModel[i].prop;

            if (key === 'key0') {
              tableModel[i].label = '添加时间';
            } else if (key === 'key1') {
              tableModel[i].label = '会员编号';
            } else if (key === 'key2') {
              tableModel[i].label = '会员姓名';
            } else if (key === 'key3') {
              tableModel[i].label = '所属派系';
            } else if (key === 'key4') {
              tableModel[i].label = '派系姓名';
            }
          }

          tableModel = tableModel.splice(0, 5);
        } else if (params.where.type === 'sta3') {
          for (var _i in tableModel) {
            var _key = tableModel[_i].prop;

            if (_key === 'key0') {
              tableModel[_i].label = '添加时间';
            } else if (_key === 'key1') {
              tableModel[_i].label = '会员编号';
            } else if (_key === 'key2') {
              tableModel[_i].label = '会员姓名';
            } else if (_key === 'key3') {
              tableModel[_i].label = '上级会员编号';
            } else if (_key === 'key4') {
              tableModel[_i].label = '上级会员名称';
            } else if (_key === 'key5') {
              tableModel[_i].label = '上级会员等级';
            }
          }

          tableModel = tableModel.splice(0, 6);
        } else if (params.where.type === 'sta4') {
          for (var _i2 in tableModel) {
            var _key2 = tableModel[_i2].prop;

            if (_key2 === 'key0') {
              tableModel[_i2].label = '添加时间';
            } else if (_key2 === 'key1') {
              tableModel[_i2].label = '会员编号';
            } else if (_key2 === 'key2') {
              tableModel[_i2].label = '会员姓名';
            }
          }

          tableModel = tableModel.splice(0, 3);
        }

        console.log('tableModel', tableModel);
        this.tableModel_1001.tableModel = tableModel;
      }

      staticCommon(params).then(function _callee2(res) {
        var tmp, where, _i3, item, _key3, j;

        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tmp = [];
                where = _this4.search.parseWhere();
                _context2.t0 = regeneratorRuntime.keys(res.rows);

              case 3:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 25;
                  break;
                }

                _i3 = _context2.t1.value;
                item = res.rows[_i3];
                _context2.t2 = regeneratorRuntime.keys(item.data);

              case 7:
                if ((_context2.t3 = _context2.t2()).done) {
                  _context2.next = 21;
                  break;
                }

                _key3 = _context2.t3.value;

                if (!(where.type === 'sta3')) {
                  _context2.next = 19;
                  break;
                }

                if (!(_key3 === 'key5')) {
                  _context2.next = 19;
                  break;
                }

                _context2.t4 = regeneratorRuntime.keys(_this4.gradeList);

              case 12:
                if ((_context2.t5 = _context2.t4()).done) {
                  _context2.next = 19;
                  break;
                }

                j = _context2.t5.value;

                if (!(_this4.gradeList[j].tag == item.data[_key3])) {
                  _context2.next = 17;
                  break;
                }

                item.data[_key3] = _this4.gradeList[j].name;
                return _context2.abrupt("break", 19);

              case 17:
                _context2.next = 12;
                break;

              case 19:
                _context2.next = 7;
                break;

              case 21:
                console.log('item.data', item.data);
                tmp.push(item.data);
                _context2.next = 3;
                break;

              case 25:
                resolve({
                  total: res.count,
                  data: tmp
                });

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        });
      });
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {//if (isEdit){
      //  params.id = row.id
      //}
      //xxxAdd(params).then(async res=>{
      //  resolve()
      //})
    },
    reqDel: function reqDel(params, resolve) {
      var ids = params.map(function (item) {
        return item.id;
      }); //xxxDel({id:ids}).then(async res=>{
      //  resolve()
      //})
    },
    onClickLink: function onClickLink(prop, row) {//点击列表link类型回调
    },
    onClickRowButton: function onClickRowButton(btnIndex, row) {//点击列表按钮回调
    },
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {//点击列表头部按钮回调
    },
    onSummary: function onSummary(param) {//列表尾部合计回调
    },
    onSwitchChange: function onSwitchChange(val, prop, row) {//列表中switch变化事件
    },
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      //条件菜单按钮点击事件
      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      } else if (btnData.tag === this.$tempModel.buttonTag.import) {
        var header = btnData.header;
        var results = btnData.results;
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    },
    onRowButtonShow: function onRowButtonShow(btnIndex, row) {
      return true;
    }
  }
};